/* eslint-disable react/no-danger */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './paragraph.scss';

const Paragraph = ({ paragraph, isExpanded }) => {
  const {
    heading,
    mobile,
    desktop,
    expanded,
  } = paragraph;

  const classes = classnames(
    'gw-paragraph',
    {
      'gw-paragraph--expanded': isExpanded,
      'gw-paragraph--hide-heading': !isExpanded && !!expanded,
    },
  );

  return (
    <div className={classes}>
      { !!heading && (
        <h2 className="gw-paragraph__h2">{heading}</h2>
      )}
      {mobile && (
        <div
          className="gw-paragraph__mobile"
          dangerouslySetInnerHTML={{ __html: mobile }}
        />
      )}
      {desktop && (
        <div
          className="gw-paragraph__desktop"
          dangerouslySetInnerHTML={{ __html: desktop }}
        />
      )}
      {expanded && (
        <div
          className="gw-paragraph__expanded"
          dangerouslySetInnerHTML={{ __html: expanded }}
        />
      )}
    </div>
  );
};

Paragraph.propTypes = {
  paragraph: PropTypes.shape({
    mobile: PropTypes.string,
    desktop: PropTypes.string,
    expanded: PropTypes.string,
    heading: PropTypes.string,
  }).isRequired,
  isExpanded: PropTypes.bool,
};

Paragraph.defaultProps = {
  isExpanded: false,
};

export default Paragraph;
